import http from '../httpService';


export function createFinanceForm(payload) {
  return http.post('/finance-forms', payload);
}
export function editFinanceForm(id,payload) {
  return http.put(`/finance-forms/${id}`,payload)
}
export function getFinanceForm(id) {
  return http.get(`/finance-forms?cycleId.equals=${id}`)
}
export function getFinanceOverallRiskAssessmentLevels() {
  return http.get(`/finance-overall-risk-assessment-levels`)
}